module.exports = __webpack_public_path__ + "img/symbol_16_normal.3074bc00.png";